import { render, staticRenderFns } from "./price-list.vue?vue&type=template&id=d7e83c3c&scoped=true"
import script from "./price-list.vue?vue&type=script&lang=js"
export * from "./price-list.vue?vue&type=script&lang=js"
import style0 from "./price-list.vue?vue&type=style&index=0&id=d7e83c3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e83c3c",
  null
  
)

export default component.exports